<template>
  <article class="table-card">
    <h6 class="table-card__title">Ekonomisk översikt</h6>
    <table class="table-card__table table-card--padding">
      <tr
        :key="i"
        v-for="( item, i ) in options.items"
      >
        <td class="table-card--td-spacing"> {{ item.name }} </td>
        <td class="table-card--td-spacing">
          <router-link
            v-if="item.link"
            class="link link--green table-card__value"
            to="/assets"
          >
            <span v-if="item.value === 'X'">
              Fyll i här!
            </span>

            <span v-else>
              {{ item.value }}
            </span>
          </router-link>
          <p class="table-card__value" v-else>
            {{ item.value }}
          </p>
        </td>
      </tr>
    </table>
    <table class="table-card__table table-card__sum">
      <tr>
        <td class="table-card__sum-text table-card--td-spacing"> Summa </td>
        <td class="table-card__sum-value table-card--td-spacing"> {{ options.total }} </td>
      </tr>
    </table>
  </article>
</template>

<script>
export default {
  name: 'TableCard',
  props: [ 'options' ],
}
</script>

<style lang="scss" scoped>
.table-card {
  height: 100%;
  display: grid;
  grid-auto-rows: max-content 1fr;
  gap: 1rem;
  padding: 0; // Overrides card padding

  &__title {
    padding: 1rem 0 0 1rem;
  }

  &__table {
    width: 100%;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    height: 100%;
    border-collapse: collapse;
  }

  &--td-spacing {
    width: 50%;
    padding: .5rem 1rem;
  }

  &__sum {
    border-bottom-left-radius: 0.625rem;
    border-bottom-right-radius: 0.625rem;
    background-color: $gray;
    margin: 0; // Overrides table margin
  }

  &__sum-text {
    color: $light;
  }

  &__sum-value {
    color: $light;
  }
}
</style>